export default __webpack_public_path__ + "images/0xd0660cd418a64a1d44e9214ad8e459324d8157f1.png";